import React, { useState, useEffect } from 'react';
import api from '../services/api';
import PortalLayout, { card, StateMsg, SearchBar, matchZoek, datumTijdNL } from '../components/PortalLayout';

const TYPE_KLEUR = {
  storing: { bg: '#fef2f2', fg: '#b91c1c' },
  onderhoud: { bg: '#eff6ff', fg: '#1d4ed8' },
  werkorder: { bg: '#ecfdf5', fg: '#047857' },
  inspectie: { bg: '#f5f3ff', fg: '#6d28d9' },
  reparatie: { bg: '#fff7ed', fg: '#c2410c' },
  bezoek: { bg: '#f1f5f9', fg: '#475569' },
};

export default function Logboek() {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(null);
  const [zoek, setZoek] = useState('');
  useEffect(() => {
    api.get('/klantportaal/logs')
      .then((r) => setItems(r.data.logs || []))
      .catch(() => setError('Kon logboek niet laden'));
  }, []);
  const [typeFilt, setTypeFilt] = useState('');
  const [periode, setPeriode] = useState('');
  const types = [...new Set((items || []).map((l) => l.type).filter(Boolean))].sort();
  const inPeriode = (l) => {
    if (!periode) return true;
    const d = new Date(l.created_at);
    const nu = new Date();
    if (periode === 'week') return (nu - d) < 7 * 864e5;
    if (periode === 'maand') return (nu - d) < 31 * 864e5;
    return true;
  };
  const zichtbaar = (items || [])
    .filter((l) => !typeFilt || l.type === typeFilt)
    .filter(inPeriode)
    .filter((l) => matchZoek(zoek, l.type, l.beschrijving, l.object_naam));
  return (
    <PortalLayout titel="Logboek">
      {items && items.length > 0 && (<>

        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10, alignItems: 'center' }}>
          {types.map((t) => (
            <div key={t} onClick={() => setTypeFilt(typeFilt === t ? '' : t)}
              style={{ padding: '6px 14px', borderRadius: 20, fontSize: 13, cursor: 'pointer', fontWeight: 600, textTransform: 'capitalize',
                background: typeFilt === t ? '#00D4AA' : '#fff', color: typeFilt === t ? '#fff' : '#64748b',
                border: '1px solid ' + (typeFilt === t ? '#00D4AA' : '#e2e8f0') }}>{t}</div>
          ))}
          <select value={periode} onChange={(e) => setPeriode(e.target.value)}
            style={{ marginLeft: 'auto', padding: '7px 10px', borderRadius: 10, border: '1px solid #e2e8f0', fontSize: 13, color: '#64748b', background: '#fff' }}>
            <option value="">Alles</option>
            <option value="week">Deze week</option>
            <option value="maand">Deze maand</option>
          </select>
        </div>
        <SearchBar value={zoek} onChange={setZoek} placeholder="Zoek op type, wissel of tekst..." />
      </>
      )}
      <StateMsg loading={!items && !error} error={error} leeg={items && items.length === 0} leegTekst="Nog geen logboek-items." />
      {items && items.length > 0 && (
        <div style={{ color: '#94a3b8', fontSize: 12, marginBottom: 10 }}>{zichtbaar.length} van {items.length}</div>
      )}
      {zichtbaar.map((l) => {
        const k = TYPE_KLEUR[l.type] || { bg: '#f1f5f9', fg: '#475569' };
        return (
          <div key={l.id} style={card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              <span style={{ background: k.bg, color: k.fg, fontSize: 11, fontWeight: 700, padding: '3px 8px', borderRadius: 6, textTransform: 'uppercase', letterSpacing: 0.3 }}>{l.type}</span>
              <span style={{ color: '#94a3b8', fontSize: 12 }}>{datumTijdNL(l.created_at)}</span>
            </div>
            {l.object_naam && (
              <div style={{ color: '#00D4AA', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>{l.object_naam}</div>
            )}
            <div style={{ color: '#1e293b', fontSize: 14, whiteSpace: 'pre-wrap' }}>{l.beschrijving}</div>
          </div>
        );
      })}
    </PortalLayout>
  );
}
